import { GetSingleUserInfo,GetSpecialTikets } from "../until/ZeusApiSDK/Logic/FinancialLogic";
const phoneReg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/; //电话
const localTelReg = /^(\d{3,4}-)?\d{7,8}$/; //本地电话传真
const emailReg = /^[a-z0-9A-Z]+([._\\-]*[a-z0-9A-Z])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/; //邮箱
const IdNumreg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/; //身份证
const numReg = /^-?\d{1,4}(?:\.\d{1,2})?$/; //小数点后1到2位

var isMobileNumber = (rule, value, callback) => {
  if (!value) {
    return new Error("请输入电话号码");
  } else {
    const isPhone = phoneReg.test(value);
    value = Number(value); //转换为数字
    if (typeof value === "number" && !isNaN(value)) {
      //判断是否为数字
      value = value.toString(); //转换成字符串
      if (value.length < 0 || value.length > 12 || !isPhone) {
        //判断是否为11位手机号
        callback(new Error("请输入正确的手机号吗"));
      } else {
        callback();
      }
    } else {
      callback(new Error("请输入电话号码"));
    }
  }
};

var isTelOrFax = (rule, value, callback) => {
  if (!value) {
    callback();
  } else {
    const isTel = localTelReg.test(value);
    if (value.length < 10 || value.length > 13 || !isTel) {
      //判断传真字符范围是在10到13
      callback(new Error("请输入正确的固话或传真"));
    } else {
      callback();
    }
  }
};

var isEmail = (rule, value, callback) => {
  if (!value) {
    callback();
  } else {
    const email = emailReg.test(value);
    if (!email) {
      callback(new Error("请输入正确的邮箱"));
    } else {
      callback();
    }
  }
};

var isCardId = (rule, value, callback) => {
  if (!value) {
    return new Error("请输入身份证号)");
  } else {
    const card = IdNumreg.test(value);
    if (!card) {
      //判断座机为12位

      callback(new Error("身份证格式如:423024xxxx0216xxxx"));
    } else {
      callback();
    }
  }
};

var isPrice = (rule, value, callback) => {
  if (!value) {
    callback();
  } else {
    if (numReg.test(value)) {
      callback();
    } else {
      callback(new Error("数字格式:小数点后可加1到2位")); //如:1 或1.8 或1.85
    }
  }
};
var CheckSpecialTicketsOnly=(rule, value, callback) => {
    if (!value) {
      callback();
    } else {
      GetSpecialTikets(value).then(res => {
        if (res.length>0) {
          callback(new Error("账户专票已存在"));
        } else {
          callback();
        }  
      });
    }
  };
var CheckFinancialUserOnly = (rule, value, callback) => {
  if (!value) {
    callback();
  } else {
    GetSingleUserInfo(value).then(res => {
      //console.log(res.Uid != "undefined");
      if (res) {
        callback(new Error("账户ID已存在"));
      } else {
        callback();
      }
    });
  }
};
var checkData =(rule, value, callback) =>{
  if (value) {
    if (/[\u4E00-\u9FA5]/g.test(value)) {
      callback(new Error('不能输入汉字'));
    } else {
      callback();
    }
  }
  callback();
}
export { isMobileNumber, isTelOrFax, isEmail, isCardId, isPrice,CheckFinancialUserOnly,CheckSpecialTicketsOnly,checkData };
